import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client.js';
import { Landing } from './Landing.js';
import { Splash } from '../components/Splash.js';

export const ENTERED_KEY = 'gilding_entered';

/**
 * Entry — what a visitor sees at the domain root.
 *
 * Signed-out arrivals get the gilded Splash cover first; tapping "Enter site"
 * reveals the wallet-connect Landing. Signed-in visitors skip the cover
 * entirely (Landing bounces them to /dashboard). The "entered" flag is held in
 * sessionStorage, so the cover shows once per visit but doesn't replay as they
 * move around the app within the same session.
 */
export function Entry() {
  const meQuery = useQuery({ queryKey: ['me'], queryFn: () => api.me(), staleTime: 30_000 });
  const authed = meQuery.data?.authenticated === true;
  const [entered, setEntered] = useState(
    () => typeof window !== 'undefined' && window.sessionStorage.getItem(ENTERED_KEY) === '1',
  );

  if (authed || entered) return <Landing />;

  return (
    <Splash
      onEnter={() => {
        try {
          window.sessionStorage.setItem(ENTERED_KEY, '1');
        } catch {
          /* private-mode storage may throw; the in-memory flag still advances */
        }
        setEntered(true);
      }}
    />
  );
}
